// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var StripeUserKey = function (x) {
    return x;
};
var tsBridgeStripeUserKey = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("StripeUserKey")("__brandStripeUserKey"));
    }
};
var writeStripeUserKey = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showStripeUserKey = Data_Show.showString;
var readStripeUserKey = Simple_JSON.readString;
var ordStripeUserKey = Data_Ord.ordString;
var newtypeStripeUserKey = {
    Coercible0: function () {
        return undefined;
    }
};
var makeStripeUserKey = StripeUserKey;
var eqStripeUserKey = Data_Eq.eqString;
export {
    StripeUserKey,
    makeStripeUserKey,
    unwrap,
    newtypeStripeUserKey,
    eqStripeUserKey,
    ordStripeUserKey,
    showStripeUserKey,
    readStripeUserKey,
    writeStripeUserKey,
    tsBridgeStripeUserKey
};
//# sourceMappingURL=index.js.map
